import React, { Component } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { PendingActionsRow } from "./PendingActionsRow";
import dashboardStyles from "../dealerDashBoard/dashboardStyles";
import styles from "../dealerDashBoard/DashboardStyles.module.scss";
import PendingActionClient from "../../../clients/PendingActionClient";
import { IS_CANADA_MARKET } from "../../../utils/EmpUtil";

const getPendingActions = ({ hideOrShow, isNsc, user }) => {
  hideOrShow(true, true);

  if (isNsc) {
    return PendingActionClient.getNscPendingActionsNotifications(user);
  }

  return Promise.resolve({
    pendingActions: user.pendingActions,
  });
};

class PendingActions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      renderApp: false,
    };
    this.pendingActions = [];
  }

  componentDidMount() {
    getPendingActions(this.props)
      .then((data) => {
        this.pendingActions = this.sortByDate(data.pendingActions || []);
      })
      .catch(() => {
        this.pendingActions = [];
      })
      .finally(() => {
        this.props.hideOrShow(false);
        this.setState({ renderApp: true });
      });
  }

  sortByDate(pendingActions) {
    pendingActions.sort(function (a, b) {
      const itemA = new Date(a.dueDate.split("/").reverse());
      const itemB = new Date(b.dueDate.split("/").reverse());

      return itemA - itemB;
    });

    return pendingActions;
  }

  render() {
    return (
      this.state.renderApp && (
        <>
          <div
            style={dashboardStyles.header}
            className={styles.pendingActionsHeader}
          >
            {IS_CANADA_MARKET(this.props.user.market)
              ? this.props.t("DealerDashboard.admin")
              : this.props.t("DealerDashboard.adminAndPrice")}
            <span data-testid="pendingActionsCount">
              {" "}
              ({this.pendingActions.length})
            </span>
          </div>
          <Table data-testid="actionsTable" key="actionsTable">
            <PendingActionHeader t={this.props.t} />
            <TableBody>
              {this.pendingActions.map((pendingAction, index) => {
                const vehicleLines = pendingAction.attributes?.vehicleLines;

                if (vehicleLines) {
                  return vehicleLines.map((vehicleLine, vehicleIndex) => {
                    return PendingActionsRow(
                      pendingAction,
                      index + "-" + vehicleIndex,
                      this.props,
                      vehicleLine
                    );
                  });
                }

                return PendingActionsRow(pendingAction, index, this.props);
              })}
            </TableBody>
          </Table>
        </>
      )
    );
  }
}

const PendingActionHeader = (props) => {
  return (
    <TableHead>
      <TableRow
        style={dashboardStyles.dashboardHeader}
        className={styles.tableHeaderLine}
      >
        <TableCell style={dashboardStyles.typeHeader}>
          <div className={styles.alignStart}>
            {props.t("AdminAndPricingDashboard.type")}
          </div>
        </TableCell>
        <TableCell style={dashboardStyles.orderIdHeader}>
          <div className={styles.alignStart}>
            {props.t("AdminAndPricingDashboard.description")}
          </div>
        </TableCell>
        <TableCell style={dashboardStyles.dateHeader}>
          <div className={styles.alignStart}>
            {props.t("AdminAndPricingDashboard.dueDate")}
          </div>
        </TableCell>
        <TableCell style={dashboardStyles.actionHeader}>
          <div className={styles.alignStart}>
            {props.t("AdminAndPricingDashboard.action")}
          </div>
        </TableCell>
        <TableCell style={dashboardStyles.emptyHeader} />
      </TableRow>
    </TableHead>
  );
};

const pendingActionPropType = PropTypes.shape({
  dueDate: PropTypes.string,
  attributes: PropTypes.shape({
    vehicleLines: PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.string, PropTypes.object])
    ),
  }),
});

PendingActions.propTypes = {
  hideOrShow: PropTypes.func.isRequired,
  isNsc: PropTypes.bool,
  user: PropTypes.shape({
    market: PropTypes.string,
    pendingActions: PropTypes.arrayOf(pendingActionPropType),
  }).isRequired,
  t: PropTypes.func.isRequired,
};

PendingActions.defaultProps = {
  isNsc: false,
};

PendingActionHeader.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation("emp")(PendingActions);
